// Shared placeholder for hub sections that are not built yet.

import { Link, useLocation } from "react-router-dom";
import { Construction, House } from "lucide-react";

import { HUB_SECTIONS } from "@/lib/nav";
import { Button } from "@/components/ui/button";

export default function ComingSoon() {
  const { pathname } = useLocation();
  const section = HUB_SECTIONS.find((s) => pathname === s.href || pathname.startsWith(`${s.href}/`));
  const Icon = section?.icon ?? Construction;

  return (
    <div className="flex flex-col items-center gap-4 px-6 py-20 text-center">
      <span className="flex size-16 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Icon className="size-8" strokeWidth={1.5} />
      </span>
      <div>
        <h2 className="text-base font-semibold">Coming soon</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          {section ? `${section.label} is part of a later phase.` : "This section is part of a later phase."}{" "}
          Until then, use the desktop application.
        </p>
      </div>
      <Button
        nativeButton={false}
        variant="outline"
        render={<Link to="/" />}
      >
        <House /> Back to home
      </Button>
    </div>
  );
}
